<template>
    <button
        v-bind="$attrs"
        :class="{
            'p-1': size === 'md',
            'bg-indigo-600 hover:bg-indigo-700': disabled === false,
            'bg-gray-600 hover:bg-gray-700': disabled === true,
        }"
        :type="type"
        :disabled="disabled"
        class="inline-flex items-center border border-transparent rounded-full shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
            class="h-5 w-5"
        >
            <path
                fill-rule="evenodd"
                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                clip-rule="evenodd"
            ></path>
        </svg>
    </button>
</template>

<script>
export default {
    name: 'PlusButton',
    props: {
        size: {
            type: String,
            default: 'sm',
        },
        type: {
            type: String,
            default: 'button',
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
};
</script>
